/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-underscore-dangle */

const defaultFunctions = {
  checkStatusOfItem(api, panelId, itemId, state, value, range = null) {
    if (range) {
      return (
        api.panels.find((p) => p.id === panelId).itemsById[itemId]
          .displayFunctionValues[state]
          <= value + range
        && api.panels.find((p) => p.id === panelId).itemsById[itemId]
          .displayFunctionValues[state]
          >= value - range
      )
    }
    return (
      api.panels.find((p) => p.id === panelId).itemsById[itemId]
        .displayFunctionValues[state] === value
    )
  },
  getItem(api, panelId, itemId) {
    const panel = api.panels.find((p) => p.id === panelId)
    const item = panel.itemsById[itemId]
    const element = api.elements.itemsById[item.itemId]
    return { panel, item, element }
  },
  getAction(api, element, activeZoneId) {
    const zone = element.activeZones.find(
      (activeZone) => activeZone.id === activeZoneId,
    )
    return api.elements.module[zone.function]
  },
  dispatchAction(api, panelId, itemId, activeZoneId, params) {
    const { item, element } = api.defaults.funcs.getItem(api, panelId, itemId)
    const action = api.defaults.funcs.getAction(api, element, activeZoneId)
    const zone = element.activeZones.find(
      (activeZone) => activeZone.id === activeZoneId,
    )

    const localClick = api.geometry.getCenter(zone.coords)
    const globalClick = api.geometry.reverseTransformPoint(
      localClick,
      item.coords,
      item.rotation,
    )
    const paramsObject = {
      ...api.panelComponent.getParamsObject(
        globalClick,
        localClick,
        item,
        zone,
      ),
      ...(params || {})
    }

    action(
      element,
      item,
      api.context,
      api.getActionApi(element, item),
      paramsObject,
    )
  },
  updateStateOfItem(api, panelId, itemId, state, value) {
    api.panels.find((p) => p.id === panelId).itemsById[
      itemId
    ].displayFunctionValues[state] = value
  },
  checkCurrentInstrument(paramsObject, value) {
    if (paramsObject.isAutoPlay) {
      return true
    }
    return paramsObject.tool === value
  }
}

export default defaultFunctions
